export enum EPageNameCustom {
  FAQS_PAGE = 'FAQS_PAGE',
  PRIVACY_PAGE = 'PRIVACY_PAGE',
  TERMS_AND_CONDITIONS_PAGE = 'TERMS_AND_CONDITIONS_PAGE',
  REGISTER_KIT_PAGE = 'REGISTER_KIT_PAGE',
  PARTNERSHIPS_PAGE = 'PARTNERSHIPS_PAGE',
  CHAT_PAGE = 'CHAT_PAGE',
  SURVEY_PAGE = 'SURVEY_PAGE',
  UPDATE_PROFILE_PAGE = 'UPDATE_PROFILE_PAGE',
  BREEDS_PAGE = 'BREEDS_PAGE',
  BREED_DETAILS_PAGE = 'BREED_DETAILS_PAGE',
  TRAITS_PAGE = 'TRAITS_PAGE',
  TRAIT_INFO_PAGE = 'TRAIT_INFO_PAGE',
  LIHP_HEALTH_TRAITS_LIST = 'LIHP_HEALTH_TRAITS_LIST',
  HEALTH_TRAIT_PAGE = 'HEALTH_TRAIT_PAGE',
  MATCHES_PAGE = 'MATCHES_PAGE',
  HEALTH_UPGRADE_PAGE = 'HEALTH_UPGRADE_PAGE',
  PROFILE_PAGE = 'PROFILE_PAGE',
  DASHBOARD_PAGE = 'DASHBOARD_PAGE',
  CONTACT_US_PAGE = 'CONTACT_US_PAGE',
  RETURN_LABEL_PAGE = 'RETURN_LABEL_PAGE',
  SIGN_IN_PAGE = 'SIGN_IN_PAGE',
  OFFER_PAGE = 'OFFER_PAGE',
  CO_BRANDED_PAGE = 'CO_BRANDED_PAGE',
  CHECKOUT_PAGE = 'CHECKOUT_PAGE',
}

interface RouteMapping {
  pattern: RegExp;
  pageId: EPageNameCustom;
}

export const PAGE_ROUTES: RouteMapping[] = [
  {
    pattern: /^faqs($|\/)/,
    pageId: EPageNameCustom.FAQS_PAGE,
  },
  {
    pattern: /^privacy($|\/)/,
    pageId: EPageNameCustom.PRIVACY_PAGE,
  },
  {
    pattern: /^terms_conditions($|\/)/,
    pageId: EPageNameCustom.TERMS_AND_CONDITIONS_PAGE,
  },
  {
    pattern: /^register($|\/)/,
    pageId: EPageNameCustom.REGISTER_KIT_PAGE,
  },
  {
    pattern: /^partnerships($|\/)/,
    pageId: EPageNameCustom.PARTNERSHIPS_PAGE,
  },
  {
    pattern: /^all\/chat($|\/)/,
    pageId: EPageNameCustom.CHAT_PAGE,
  },
  {
    pattern: /^survey($|\/)/,
    pageId: EPageNameCustom.SURVEY_PAGE,
  },
  {
    pattern: /^[\w-]+\/breeds$/,
    pageId: EPageNameCustom.BREEDS_PAGE,
  },
  {
    pattern: /^[\w-]+\/breeds\//,
    pageId: EPageNameCustom.BREED_DETAILS_PAGE,
  },
  {
    pattern: /^[\w-]+\/traits$/,
    pageId: EPageNameCustom.TRAITS_PAGE,
  },
  {
    pattern: /^[\w-]+\/traits\/[\w-]+$/,
    pageId: EPageNameCustom.TRAIT_INFO_PAGE,
  },
  {
    pattern: /^[\w-]+\/health-report$/,
    pageId: EPageNameCustom.LIHP_HEALTH_TRAITS_LIST,
  },
  {
    pattern: /^[\w-]+\/health-report\//,
    pageId: EPageNameCustom.HEALTH_TRAIT_PAGE,
  },
  {
    pattern: /^[\w-]+\/matches($|\/)/,
    pageId: EPageNameCustom.MATCHES_PAGE,
  },
  {
    pattern: /^[\w-]+\/health-upgrade$/,
    pageId: EPageNameCustom.HEALTH_UPGRADE_PAGE,
  },
  {
    pattern: /^[\w-]+\/update-profile/,
    pageId: EPageNameCustom.UPDATE_PROFILE_PAGE,
  },
  {
    pattern: /^profile($|\/)/,
    pageId: EPageNameCustom.PROFILE_PAGE,
  },
  {
    pattern: /^contact_us($|\/)/,
    pageId: EPageNameCustom.CONTACT_US_PAGE,
  },
  {
    pattern: /^return-label($|\/)/,
    pageId: EPageNameCustom.RETURN_LABEL_PAGE,
  },
  {
    pattern: /^sign-in($|\/)/,
    pageId: EPageNameCustom.SIGN_IN_PAGE,
  },
  {
    pattern: /^offer($|\/)/,
    pageId: EPageNameCustom.OFFER_PAGE,
  },
  {
    pattern: /^co-branded($|\/)/,
    pageId: EPageNameCustom.CO_BRANDED_PAGE,
  },
  {
    pattern: /^checkout($|\/)/,
    pageId: EPageNameCustom.CHECKOUT_PAGE,
  },
  {
    pattern: /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
    pageId: EPageNameCustom.DASHBOARD_PAGE,
  },
];
